import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import GetDashboardsClient from 'use-case/dashboards/get/getDashboardsClient';
import { asDashboard, DashboardJson } from 'adapter/out/client/dashboard/mappers/dashboard';
import GetDashboardsCriteria from 'use-case/dashboards/get/getDashboardsCriteria';
import { parseOrder } from 'adapter/in/dashboards/utils/parseDirection';

export default (httpClient: httpClientFunction, baseUrl: string): GetDashboardsClient => (criteria: GetDashboardsCriteria) =>
    httpClient(
        `${baseUrl}/dashboards/dashboards${
            criteria.sort !== undefined && criteria.order !== undefined
                ? `?sort=${criteria.sort.toUpperCase()}&order=${parseOrder(criteria.order)}`
                : ''
        }`,
        {}
    )
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asDashboards)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));
const asDashboards = (dashboardsJson: DashboardJson[]) => dashboardsJson.map((dashboardJson: DashboardJson) => asDashboard(dashboardJson));
